import React from 'react'
import {TextField, TextFieldProps} from "@mui/material"

type CustomTextFieldProps = { sx?: React.CSSProperties } & TextFieldProps

const Field: React.FC<CustomTextFieldProps> = (props) => {
    return <TextField {...props} sx={[props?.sx as React.CSSProperties, {margin: '1rem', backgroundColor: 'white'}]} fullWidth/>
}

export default Field
